module.exports = __webpack_public_path__ + "static/img_4613-7e9d963e49ef6c877015b07391fc9ea2.webp";